import type {RailItem} from '@app/components/rail';
import {useLocation} from '@app/hooks/use-location';
import type {
	PlaylistRailItemFragment,
	AlbumRailItemFragment,
} from '../graphql/generated';

type Transformer<T, Y> = (init: T) => Y;

type PlaylistEdges = ReadonlyArray<{
	readonly node: PlaylistRailItemFragment | null;
}>;
type AlbumEdges = ReadonlyArray<{readonly node: AlbumRailItemFragment | null}>;
type PlaylistTransformer = Transformer<PlaylistEdges | undefined, RailItem[]>;
type AlbumTransformer = Transformer<AlbumEdges | undefined, RailItem[]>;
export const useAsRailItems = (): {
	albumAsRailItem: AlbumTransformer;
	playlistAsRailItem: PlaylistTransformer;
} => {
	const {getDeezerUrl} = useLocation();
	return {
		playlistAsRailItem: (edges: PlaylistEdges | undefined) =>
			(edges ?? [])
				.filter(({node}) => node !== null)
				.map(({node}) => ({
					trad: node?.title ?? '',
					link: getDeezerUrl(`/playlist/${node?.id}`),
					src: node?.picture?.urls[0] ?? '',
					label: `playlist-${node?.id}`,
				})),
		albumAsRailItem: (edges: AlbumEdges | undefined) =>
			(edges ?? [])
				.filter(({node}) => node !== null)
				.map(({node}) => ({
					trad: node?.displayTitle ?? '',
					link: getDeezerUrl(`/album/${node?.id}`),
					src: node?.cover?.urls[0] ?? '',
					label: `album-${node?.id}`,
				})),
	};
};
